window.addEventListener('DOMContentLoaded', () => {
  const heights = {
    1: '29%',
    2: '45%',
    3: '55%',
    4: '65%',
    5: '90%',
  };

  const growStagger = 0.05;
  const duration = 0.75;

  document.querySelectorAll('[data-cta-section]').forEach((section) => {
    const button = section.querySelector('[data-cta-button]');
    const container = section.querySelector('[data-cta-fade-container]');
    if (!button || !container || typeof gsap === 'undefined') return;

    const fadeParts = [...container.querySelectorAll('[data-cta-fade]')].sort(
      (a, b) =>
        Number(a.getAttribute('data-cta-fade')) -
        Number(b.getAttribute('data-cta-fade'))
    );

    if (!fadeParts.length) return;

    gsap.set(fadeParts, { height: '0%' });

    const tweenProps = {
      duration,
      ease: 'expo.out',
      stagger: growStagger,
    };

    function enter() {
      gsap.killTweensOf(fadeParts);
      gsap.to(fadeParts, {
        ...tweenProps,
        height: (_, el) => heights[Number(el.getAttribute('data-cta-fade'))],
      });
    }

    function leave() {
      gsap.killTweensOf(fadeParts);
      gsap.to(fadeParts, {
        ...tweenProps,
        height: '0%',
      });
    }

    button.addEventListener('mouseenter', enter);
    button.addEventListener('mouseleave', leave);
    button.addEventListener('focus', enter);
    button.addEventListener('blur', leave);
  });
});
